<script lang="ts">
  import type { Collection } from "bildebanken-model";
  import Dialog from "components/Common/Dialog.svelte";
  import { useCreateCollectionMutation } from "./collectionOperations";
  import { ConflictError } from "services/collections/api";
  import { notify } from "services/notifications";
  import { escapeHtml } from "utils/fns";

  let collectionName = "";
  let nameConflict = false;
  export let onCreated: (collection: Collection) => void = () => {};
  export let id = "create-collection-dialog";

  const createCollectionMutation = useCreateCollectionMutation(onCreated);

  async function onConfirm(): Promise<void> {
    try {
      await $createCollectionMutation.mutateAsync({
        name: collectionName,
        visibleTo: { level: "owner", users: [] },
      });
      notify(`Samling ${escapeHtml(collectionName)} er opprettet`, "success", 3000);
    } catch (error) {
      if (error instanceof ConflictError) {
        nameConflict = true;
      }
      throw error;
    }
  }
</script>

<Dialog
  {id}
  headerText={"Opprett samling"}
  confirmText={"Opprett"}
  {onConfirm}
  onOpen={() => {
    collectionName = "";
    nameConflict = false;
  }}
  confirmDisabled={!collectionName.trim()}
>
  <h3>Velg egenskaper</h3>

  <label for="create-collection-name">Navn</label>
  <input
    class="org-input"
    style="margin-bottom: var(--org-xsmall)"
    id="create-collection-name"
    type="text"
    placeholder="Mine favoritter"
    aria-invalid={nameConflict}
    on:input={() => (nameConflict = false)}
    bind:value={collectionName}
  />
  {#if nameConflict}
    <span class="org-warning">En samling med dette navnet finnes allerede</span>
  {/if}
</Dialog>
